export default __webpack_public_path__ + "static/media/delivered.35a721ab.svg";